import type { ICashbackMainPageResources } from "./CashbackMainPage.Resources";

export const CashbackMainPageResourcesEn: ICashbackMainPageResources = {
    cashbackProcessSteps: {
        mobilesTitle: "Step by step cashback",
        buttonTextClose: "Show less",
        buttonTextOpen: "Show more",
        stepper: {
            step1Title: "Log in to goodie",
            step1Description: "Login in to goodie cashback on goodie.pl or in goodie mobile app.",
            step2Title: "Select store and shop",
            step2Description:
                "Select store in goodie and press 'Go to shop' button. Choose products and make payment - the same way you always do!",
            step3Title: "Get cashback",
            step3Description:
                "You will find cashback amount on your goodie user account. After transaction is confirmed by the store, your cashback will be accepted.",
            step4Title: "Receive cash to your bank account",
            step4Description:
                "After collecting at least 21 zł of cashback you can transfer it to your account in any bank.",
        },
    },
    transactionsList: {
        tableHeader1: "ORDER",
        tableHeader1Withdrawal: "STATUS",
        tableHeader2: "PURCHASE DATE",
        tableHeader2Mobile: "DATE",
        tableHeader3: "PURCHASE VALUE",
        tableHeader4: "CASHBACK",
        tableHeader4Withdrawal: "AMOUNT",
        emptyPendingTransactionsTitle: "You do not have any pending transactions yet",
        emptyPendingTransactionsDescription1:
            "The cashback for purchases made by you that have not yet been confirmed by the store will appear here.",
        emptyPendingTransactionsDescription2:
            "The waiting time for approval varies by store. You can check the average waiting time in the store description at goodie.",
        emptyApprovedTransactionsTitle: "You do not have any transactions approved yet",
        emptyApprovedTransactionsDescription1:
            "This is where the cashback returns that have been confirmed by the stores will appear, from which you can make withdrawals.",
        emptyApprovedTransactionsDescription2:
            "The payout is possible after accumulating at least PLN 21 cashback.",
        emptyWithdrawalsTransactionsTitle: "You don't have withdrawals yet",
        emptyWithdrawalsTransactionsDescription1:
            "Information about cashback withdrawals made will appear here.",
        emptyWithdrawalsTransactionsDescription2:
            "A transfer with withdrawal usually takes no more than 3 business days.",
        emptyRejectedTransactionsTitle: "You do not have rejected transactions yet",
        emptyRejectedTransactionsDescription:
            "Information about cashback withdrawals made will appear here. A transfer with withdrawal usually takes no more than 3 business days.",
        cashbackLinkTitle: "Report missing transactions!",
        pendingBtn: "Pending",
        approvedBtn: "Accepted",
        withdrawalBtn: "Withdrawals",
        rejectedBtn: "Rejected",
    },
    transactionsManager: {
        modalTitle: "Your transactions in goodie",
        showAllText: "All transactions",
        faqText: "Questions & Answers",
        allShopsText: "All stores ⬇",
    },
    cashbackDashboard: {
        totalAmountWithdrawalText: "Total withdrawn cashback",
        cashbackWithdrawForm: {
            title: "Withdrawal",
            amountLabel: "You are withdrawing",
            firstLastNameLabel: "First and last name",
            firstLastNameWatermarkText: "enter first and last name",
            accountNumberWatermarkText: "enter account number",
        },
    },
    bannerSectionTitle: "Hot discounts",
    brandsCashbackSection: {
        titleFavorites: "Favorite cashback stores",
        titleBrands: "All cashback stores",
        addMoreFavoritesText: "Add a store",
        searchText: "Find cashback store",
        noBrandsText:
            "There are currently no stores assigned to this category in goodie cashback. You can find similar stores offering cashback by clicking on the appropriate category above.",
        filterText: "Sort by:",
        filterOptionAlphabetic: "Alphabet",
        filterOptionPopular: "Popularity",
    },
};
